<div class="kHoster">
  <iframe *ngIf="_keditConfig && keditUrl" frameborder="0" [src]="keditUrl | safe"></iframe>
</div>
